import * as PIXI from "pixi.js";
import Game from "../Game";
import { getPolygonConDeltail } from "../types/config";
import BaseController from "./baseController";

export default class SideNumberCon extends BaseController {
  Game: Game = Game.getInstance();

  constructor() {
    super("Number Of Sides", "sideChange", 9, 3, 3, 0xFF0000);
    const { x, y, width } = getPolygonConDeltail(this.Game.getDim());
    this.Game.topContainer.addChild(this);
    this.x = x + width + 20;
    this.y = y + 50;
  }

}